import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './core/components/homepage/homepage.component';
import { ApplicationComponent } from './core/components/application/application.component';
import { SubscriptionComponent } from './core/components/subscription/subscription.component';
import { EditSubscriptionComponent } from './core/components/subscription/edit-subscription/edit-subs.component';
import { ConfirmEmailComponent } from './core/components/confirm-email/confirm-email.component';
import { CreatePasswordComponent } from './core/components/create-password/create-password.component';
import { CreateUserComponent } from './core/components/manage-users/create-user/create-user.component';
import { ManageUsersComponent } from './core/components/manage-users/manage-users/manage-users.component';
import { EditUserComponent } from './core/components/manage-users/edit-user/edit-user.component';
import { LoginComponent } from './core/components/login/login.component';
import { AccoutSettingsComponent } from './core/components/accout-settings/accout-settings.component';
import { EditProfileComponent } from './core/components/accout-settings/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './core/components/accout-settings/change-password/change-password.component';
import { AnalyticsComponent } from './core/components/analytics/analytics.component';
import { DashboardDetailsComponent } from './core/components/analytics/dashboard-details/dashboard-details.component';
import { AnalyticsHomeComponent } from './core/components/analytics/analytics-home/analytics-home.component';
import { ViewAnalyticsComponent } from './core/components/view-analytics/view-analytics.component';

import { DataProductsComponent } from './core/components/data-products/data-products.component';
import { ProductsComponent } from './core/components/data-products/products/products.component'
import { ProductDetailsComponent } from './core/components/data-products/products/product-details/product-details.component'
import { MyReportsComponent } from './core/components/data-products/my-reports/my-reports.component'
import { AppDetailsComponent } from './core/components/application/app-details/app-details.component';
import { ManageRequestsComponent } from './core/components/manage-requests/manage-requests.component';
import { ManageModulesComponent } from './core/components/manage-modules/manage-modules.component';
import { EditModuleComponent } from './core/components/manage-modules/edit-module/edit-module.component';
import { authGuard } from './shared/auth.service';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: HomepageComponent,
    canActivate: [authGuard] },
  { path: 'all-analytics', component: AnalyticsComponent,
    canActivate: [authGuard] },
  { path: 'app', component: ApplicationComponent,
    canActivate: [authGuard] },
  { path: 'app-details/:id', component: AppDetailsComponent,
    canActivate: [authGuard] },
  { path: 'subscription', component: SubscriptionComponent,
    canActivate: [authGuard] },
  { path: 'create-subscription', component: EditSubscriptionComponent,
    canActivate: [authGuard] },
  { path: 'confirm-email', component: ConfirmEmailComponent },
  { path: 'create-password', component: CreatePasswordComponent },
  { path: 'forgot-password', component: LoginComponent },
  { path: 'account-settings', component: AccoutSettingsComponent,
    canActivate: [authGuard] },
  { path: 'profile', component: EditProfileComponent,
    canActivate: [authGuard] },
  { path: 'change-password', component: ChangePasswordComponent,
    canActivate: [authGuard] },

  { path: 'edit-subscription/:subscriptionId', component: EditSubscriptionComponent,
    canActivate: [authGuard]},
  { path: 'manage-requests', component: ManageRequestsComponent,
    canActivate: [authGuard] },
  { path: 'manage-users', component: ManageUsersComponent,
    canActivate: [authGuard] },
  { path: 'create-users', component: CreateUserComponent,
    canActivate: [authGuard] },
  { path: 'edit-user/:id', component: EditUserComponent,
    canActivate: [authGuard] },
  { path: 'view-details/:id', component: DashboardDetailsComponent,
    canActivate: [authGuard] },
  { path: 'analytics', component: AnalyticsHomeComponent,
    canActivate: [authGuard] },
  { path: 'analytics/:moduleId', component: ViewAnalyticsComponent,
    canActivate: [authGuard] },
  { path: 'data-products', component: DataProductsComponent, 
    children: [
      { path: 'all', component: ProductsComponent,
    canActivate: [authGuard] },
      { path: 'myReports', component: MyReportsComponent,
    canActivate: [authGuard] },
      { path: '', redirectTo: 'all', pathMatch: 'full' }
    ]
  },
  { path: 'data-products/details/:id', component: ProductDetailsComponent },
  {path: 'login', component: LoginComponent},
  {path: 'manage-modules', component: ManageModulesComponent},
  {path: 'create-module', component: EditModuleComponent},
  {path: 'manage-module/:moduleId', component: EditModuleComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
